// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'dashboard.filtros.date': 'Data',
    'dashboard.filtros.cliente': 'Cliente',
    'dashboard.filtros.cliente.search': 'Buscar cliente…',
    'dashboard.filtros.contrato': 'Contrato',
    'dashboard.filtros.contrato.search': 'Buscar contrato…',
    'dashboard.filtros.regiao': 'Região',
    'dashboard.filtros.regiao.search': 'Buscar região…',
    'dashboard.filtros.destino': 'Destino',
    'dashboard.filtros.destino.search': 'Buscar destino…',
    'dashboard.filtros.dupla': 'Dupla',
    'dashboard.filtros.dupla.search': 'Buscar dupla…',
    'dashboard.filtros.clear': 'Limpar',
  },
  en: {
    'dashboard.filtros.date': 'Date',
    'dashboard.filtros.cliente': 'Customer',
    'dashboard.filtros.cliente.search': 'Search customer…',
    'dashboard.filtros.contrato': 'Contract',
    'dashboard.filtros.contrato.search': 'Search contract…',
    'dashboard.filtros.regiao': 'Region',
    'dashboard.filtros.regiao.search': 'Search region…',
    'dashboard.filtros.destino': 'Destination',
    'dashboard.filtros.destino.search': 'Search destination…',
    'dashboard.filtros.dupla': 'Pair',
    'dashboard.filtros.dupla.search': 'Search pair…',
    'dashboard.filtros.clear': 'Clear',
  },
  es: {
    'dashboard.filtros.date': 'Fecha',
    'dashboard.filtros.cliente': 'Cliente',
    'dashboard.filtros.cliente.search': 'Buscar cliente…',
    'dashboard.filtros.contrato': 'Contrato',
    'dashboard.filtros.contrato.search': 'Buscar contrato…',
    'dashboard.filtros.regiao': 'Región',
    'dashboard.filtros.regiao.search': 'Buscar región…',
    'dashboard.filtros.destino': 'Destino',
    'dashboard.filtros.destino.search': 'Buscar destino…',
    'dashboard.filtros.dupla': 'Pareja',
    'dashboard.filtros.dupla.search': 'Buscar pareja…',
    'dashboard.filtros.clear': 'Limpiar',
  },
}
